module.exports = __webpack_public_path__ + "static/media/login_agrolife.028ea4d1.svg";